"use client";

import { c as _c } from "react/compiler-runtime";
import { CenterAligned, FlexColumn, FormControl, List, ListItem, ListItemAvatar, ListItemContent, ListItemDescription, ListItemSide, ListItemTitle, Spinner, TextBody, TextDisplay } from "@opensea/ui-kit";
import { useMountEffect } from "@opensea/ui-kit/hooks";
import { PhoneAndroid, VerifiedUser } from "@opensea/ui-kit/icons";
import { useState } from "react";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { AuthCode } from "../../../components/AuthCode";
import { ModalBackButton } from "../../../components/Modal";
import { PasteFromClipboardButton } from "../../../components/PasteFromClipboardButton";
import { MfaChallengeActions, MfaChallengeState } from "../../../stores/mfaChallengeStore";
import { MfaHandlerActions, MfaHandlerState } from "../../../stores/mfaHandlerStore";
const SelectChallengeOptionStep = () => {
  const $ = _c(63);
  const t = useTranslations("wallet.MfaChallenge");
  const {
    initializingStep
  } = useSnapshot(MfaChallengeState);
  let t0;
  if ($[0] !== t) {
    t0 = t("chooseSecurityOption");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextDisplay size="sm">{t0}</TextDisplay>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("mfaRequired");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <TextBody color="text-secondary" size="sm">{t2}</TextBody>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <FlexColumn className="gap-4">{t1}{t3}</FlexColumn>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ListItemAvatar icon={PhoneAndroid} />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("sms");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <ListItemTitle>{t6}</ListItemTitle>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("smsDescription");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <br />;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("smsRegionRestriction");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8) {
    t11 = <ListItemDescription className="text-start">{t8}{t9}{t10}</ListItemDescription>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t7) {
    t12 = <ListItemContent>{t7}{t11}</ListItemContent>;
    $[24] = t11;
    $[25] = t7;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== initializingStep) {
    t13 = initializingStep === "challenge-sms" && <Spinner />;
    $[27] = initializingStep;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13) {
    t14 = <ListItemSide>{t13}</ListItemSide>;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t12 || $[32] !== t14) {
    t15 = <ListItem onClick={_temp}>{t5}{t12}{t14}</ListItem>;
    $[31] = t12;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <ListItemAvatar icon={VerifiedUser} />;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t) {
    t17 = t("authenticator");
    $[35] = t;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17) {
    t18 = <ListItemTitle>{t17}</ListItemTitle>;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t) {
    t19 = t("authenticatorDescription");
    $[39] = t;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <br />;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t) {
    t21 = t("authenticatorSecurityNote");
    $[42] = t;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t19 || $[45] !== t21) {
    t22 = <ListItemDescription className="text-start">{t19}{t20}{t21}</ListItemDescription>;
    $[44] = t19;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t18 || $[48] !== t22) {
    t23 = <ListItemContent>{t18}{t22}</ListItemContent>;
    $[47] = t18;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== initializingStep) {
    t24 = initializingStep === "challenge-totp" && <Spinner />;
    $[50] = initializingStep;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t24) {
    t25 = <ListItemSide>{t24}</ListItemSide>;
    $[52] = t24;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t23 || $[55] !== t25) {
    t26 = <ListItem onClick={_temp2}>{t16}{t23}{t25}</ListItem>;
    $[54] = t23;
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t15 || $[58] !== t26) {
    t27 = <List>{t15}{t26}</List>;
    $[57] = t15;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t27 || $[61] !== t4) {
    t28 = <FlexColumn className="gap-8 pt-12 pb-6">{t4}{t27}</FlexColumn>;
    $[60] = t27;
    $[61] = t4;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  return t28;
};
export const ChallengeStep = () => {
  const $ = _c(32);
  const t = useTranslations("wallet.MfaChallenge");
  const [code, setCode] = useState("");
  const {
    step,
    submissionError
  } = useSnapshot(MfaChallengeState);
  const {
    mfaMethods
  } = useSnapshot(MfaHandlerState);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = async currentCode => {
      setCode(currentCode);
      const success = await MfaChallengeActions.submitChallenge(currentCode);
      if (success) {
        MfaHandlerActions.completeChallenge();
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onSubmit = t0;
  let t1;
  if ($[1] !== step.id || $[2] !== t) {
    t1 = step.id === "challenge-sms" ? t("smsCodeInstructions") : t("authenticatorCodeInstructions");
    $[1] = step.id;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const authCodeDeliveryDetails = t1;
  let t2;
  if ($[4] !== t) {
    t2 = t("mfaRequiredTitle");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <TextDisplay className="leading-[28px]" size="sm">{t2}</TextDisplay>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== authCodeDeliveryDetails) {
    t4 = <TextBody color="text-secondary" size="sm">{authCodeDeliveryDetails}</TextBody>;
    $[8] = authCodeDeliveryDetails;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <FlexColumn className="gap-4">{t3}{t4}</FlexColumn>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("authenticationCodeLabel");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      Caption: {
        className: "justify-center"
      }
    };
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = Boolean(submissionError);
  let t9;
  if ($[16] !== code || $[17] !== t8) {
    t9 = <AuthCode autoFocus={true} error={t8} onChange={setCode} onComplete={onSubmit} value={code} />;
    $[16] = code;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== submissionError || $[20] !== t6 || $[21] !== t9) {
    t10 = <FormControl error={submissionError} hideLabel={true} label={t6} overrides={t7}>{t9}</FormControl>;
    $[19] = submissionError;
    $[20] = t6;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <PasteFromClipboardButton className="mt-8 md:hidden" onPaste={onSubmit} />;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t5) {
    t12 = <FlexColumn className="gap-8 pt-12 pb-6">{t5}{t10}{t11}</FlexColumn>;
    $[24] = t10;
    $[25] = t5;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== mfaMethods.length) {
    t13 = mfaMethods.length > 1 && <ModalBackButton onBack={MfaChallengeActions.onBack} />;
    $[27] = mfaMethods.length;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <>{t12}{t13}</>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
};
export const MfaChallenge = () => {
  const $ = _c(7);
  const {
    step,
    submitting,
    initializingStep
  } = useSnapshot(MfaChallengeState);
  const {
    mfaMethods
  } = useSnapshot(MfaHandlerState);
  let t0;
  if ($[0] !== initializingStep || $[1] !== mfaMethods[0] || $[2] !== mfaMethods.length) {
    t0 = () => {
      if (mfaMethods.length === 1 && initializingStep === undefined) {
        MfaChallengeActions.selectChallengeOption(mfaMethods[0]);
      }
    };
    $[0] = initializingStep;
    $[1] = mfaMethods[0];
    $[2] = mfaMethods.length;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  useMountEffect(t0);
  if (submitting || initializingStep) {
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CenterAligned className="h-[400px]"><Spinner /></CenterAligned>;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  switch (step.id) {
    case "select-challenge-option":
      {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <SelectChallengeOptionStep />;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "challenge-sms":
      {}
    case "challenge-totp":
      {
        let t1;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ChallengeStep />;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
  }
};
async function _temp() {
  return await MfaChallengeActions.selectChallengeOption("sms");
}
async function _temp2() {
  return await MfaChallengeActions.selectChallengeOption("totp");
}